import React, { useState } from "react";
import Slider from "react-slick";
import { FaBookOpen, FaHandsHelping, FaSeedling } from "react-icons/fa";
import "./Curriculum.css";

// ===== Classroom Images =====
import classroom1 from "../../assets/roomsandspaces/room1.webp";
import classroom2 from "../../assets/roomsandspaces/room2.webp";
import classroom3 from "../../assets/roomsandspaces/room3.webp";
import classroom4 from "../../assets/roomsandspaces/room4.webp";
import classroom5 from "../../assets/roomsandspaces/room5.webp";
import classroom6 from "../../assets/roomsandspaces/room6.webp";
import classroom7 from "../../assets/roomsandspaces/room7.webp";
import classroom8 from "../../assets/roomsandspaces/room8.webp";
import classroom9 from "../../assets/roomsandspaces/room9.webp";
import classroom10 from "../../assets/roomsandspaces/room10.webp";
import classroom11 from "../../assets/roomsandspaces/room11.webp";
import classroom12 from "../../assets/roomsandspaces/room12.webp";

// ===== Play Space Images =====
import playspace1 from "../../assets/roomsandspaces/playground1.webp";
import playspace2 from "../../assets/roomsandspaces/playground2.webp";
import playspace3 from "../../assets/roomsandspaces/playground3.webp";
import playspace4 from "../../assets/roomsandspaces/playground4.webp";
import playspace5 from "../../assets/roomsandspaces/playground5.webp";
import playspace6 from "../../assets/roomsandspaces/playground6.webp";
import playspace7 from "../../assets/roomsandspaces/playground7.webp";
import playspace8 from "../../assets/roomsandspaces/playground8.webp";
import playspace9 from "../../assets/roomsandspaces/playground9.webp";
import playspace10 from "../../assets/roomsandspaces/playground10.webp";
import playspace11 from "../../assets/roomsandspaces/playground11.webp";
import playspace12 from "../../assets/roomsandspaces/playground12.webp";
import playspace13 from "../../assets/roomsandspaces/playground13.webp";
import playspace14 from "../../assets/roomsandspaces/playground14.webp";
import playspace15 from "../../assets/roomsandspaces/playground15.webp";
import playspace16 from "../../assets/roomsandspaces/playground16.webp";

function Curriculum() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const openModal = (images) => {
    setSelectedImages(images);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3500,
  };

  const classroomImages = [
    classroom1,
    classroom2,
    classroom3,
    classroom4,
    classroom5,
    classroom6,
    classroom7,
    classroom8,
    classroom9,
    classroom10,
    classroom11,
    classroom12,
  ];

  const playSpaceImages = [
    playspace1,
    playspace2,
    playspace3,
    playspace4,
    playspace5,
    playspace6,
    playspace7,
    playspace8,
    playspace9,
    playspace10,
    playspace11,
    playspace12,
    playspace13,
    playspace14,
    playspace15,
    playspace16,
  ];

  return (
    <div className="curriculum-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay">
          <div className="hero-text">
            <h1>Our Curriculum & Play Spaces</h1>
            <p>
              Children learn through curiosity,
              creativity, and connection. Our program blends play-based
              exploration with intentional teaching moments that nurture the
              whole child.
            </p>
          </div>
        </div>
        <img
          className="hero-bg"
          src={require("../../assets/stock5.webp")}
          alt="Binkley Preschool"
        />
      </section>

      {/* Curriculum & Philosophy */}
      <section className="philosophy">
        <h2>Our Approach</h2>
        <div className="philosophy-cards">
          <div className="card">
            <FaBookOpen className="icon" />
            <h3>Play-Based Learning</h3>
            <p>
              Children explore concepts in literacy, math, science, and art
              through play, storytelling, and hands-on discovery.
            </p>
          </div>
          <div className="card">
            <FaHandsHelping className="icon" />
            <h3>Community & Care</h3>
            <p>
              Relationships are at the heart of everything we do. We foster
              empathy, kindness, and collaboration in every classroom.
            </p>
          </div>
          <div className="card">
            <FaSeedling className="icon" />
            <h3>Whole-Child Growth</h3>
            <p>
              We nurture each child’s social, emotional, physical, and cognitive
              development, helping them grow with confidence.
            </p>
          </div>
        </div>
      </section>

      <section className="curriculum-section">
        <div className="curriculum-content"> 
          <h2>Binkley's Curriculum</h2>
          <p>Here at Binkley Preschool, our emphasis is on challenging children intellectually, physically, socially, and emotionally by providing them with experiences that are both age and individually-appropriate. Teachers set the stage for hands-on learning in a stimulating manner that will instill excitement, curiosity, problem-solving, sharing, and freedom of expression. It is the role of the teacher(s) to act as a facilitator – answering questions, offering encouragement, redirecting problem situations, and helping children focus on tasks. Binkley aims to foster in each child a sense of independence and a positive self-image. Children learn best by doing! Curriculum is an ongoing learning process and it is facilitated through the use of interest centers.
          <br/><br/>
          Our teachers strive to integrate important skills into all of their lesson plans. Gross and fine motor, self-help, language, math, and science are just a few. Learning to live and cooperate within the classroom community and beyond is a goal for all Binkley Preschoolers.

</p>
        </div>  
      
      </section>

      {/* Carousel Pair Section */}
      <section className="carousel-pair-section">
        <div
          className="carousel-section"
          onClick={() => openModal(classroomImages)}
        >
          <h2>Our Classrooms</h2>
          <Slider {...sliderSettings}>
            {classroomImages.map((img, i) => (
              <div key={i} className="carousel-slide">
                <img src={img} alt={`Classroom ${i + 1}`} />
              </div>
            ))}
          </Slider>
        </div>

        <div
          className="carousel-section"
          onClick={() => openModal(playSpaceImages)}
        >
          <h2>Our Play Spaces</h2>
          <Slider {...sliderSettings}>
            {playSpaceImages.map((img, i) => (
              <div key={i} className="carousel-slide">
                <img src={img} alt={`Play Space ${i + 1}`} />
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* Modal */}
      {modalOpen && (
        <div className="carousel-modal-overlay" onClick={closeModal}>
          <div
            className="carousel-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="carousel-modal-close" onClick={closeModal}>
              ×
            </button>
            <Slider {...sliderSettings}>
              {selectedImages.map((img, i) => (
                <div key={i} className="modal-slide">
                  <img src={img} alt={`Expanded ${i + 1}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
}

export default Curriculum;
